'use es6';

import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for handling card state changes. For example, changing a sidebar's card order or changing a
 * card's collapse state
 *
 * @param {object}                                                                value                     the context value
 *
 * @param {Function}                                                              value.onCardOpenChange    callback used to change the open state of a card
 *
 * @callback onCardOpenChange
 * @param {String}                                                                legacyCardName            the card's legacy card name, currently required for collapse changes to be persisted to the server
 * @param {String}                                                                cardId                    the card's ID
 * @param {String}                                                                isOpen                    new desired open state of the card
 *
 * @param {Function}                                                              value.onCardOrderChange   callback used to change the card order in a sidebar
 *
 * @callback onCardOrderChange
 * @param { { legacyCardName: String, cardId: String, isCollapsed: Boolean } []}  orderedCards              the cards in their new desired order
 */

export const CardStateManipulationContext = /*#__PURE__*/createContext(null);
CardStateManipulationContext.Provider.propTypes = {
  value: PropTypes.shape({
    onCardOpenChange: PropTypes.func,
    onCardOrderChange: PropTypes.func
  }).isRequired
};